export const list = [
    {
        title: '一文读懂对JavaScript函数式编程的初认识',
        description: ` 函数式编程可以说是非常古老的编程方式，但是近几年变成了一个非常热门的话题。不管是Google...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E4%B8%80%E6%96%87%E8%AF%BB%E6%87%82%E5%AF%B9JavaScript%E5%87%BD%E6%95%B0%E5%BC%8F%E7%BC%96%E7%A8%8B%E7%9A%84%E5%88%9D%E8%AE%A4%E8%AF%86/%E4%B8%80%E6%96%87%E8%AF%BB%E6%87%82%E5%AF%B9JavaScript%E5%87%BD%E6%95%B0%E5%BC%8F%E7%BC%96%E7%A8%8B%E7%9A%84%E5%88%9D%E8%AE%A4%E8%AF%86.md`,
    },
    {
        title: '教你如何衡量一个网页的性能',
        description: `拥有一个良好用户体验的网页对于前端开发同学来说是一件必须做，持续做的一件事情，其中首...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E6%95%99%E4%BD%A0%E5%A6%82%E4%BD%95%E8%A1%A1%E9%87%8F%E4%B8%80%E4%B8%AA%E7%BD%91%E9%A1%B5%E7%9A%84%E6%80%A7%E8%83%BD/%E6%95%99%E4%BD%A0%E5%A6%82%E4%BD%95%E8%A1%A1%E9%87%8F%E4%B8%80%E4%B8%AA%E7%BD%91%E9%A1%B5%E7%9A%84%E6%80%A7%E8%83%BD.md`,
    },
    {
        title: 'WEB项目部署发版-通知用户在线更新方案',
        description: `技术背景 项目使用的框架为 vue2，构建工具为 webpack 问题 项目迭代频繁，每次上线...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/WEB%E9%A1%B9%E7%9B%AE%E9%83%A8%E7%BD%B2%E5%8F%91%E7%89%88-%E9%80%9A%E7%9F%A5%E7%94%A8%E6%88%B7%E5%9C%A8%E7%BA%BF%E6%9B%B4%E6%96%B0%E6%96%B9%E6%A1%88/WEB%E9%A1%B9%E7%9B%AE%E9%83%A8%E7%BD%B2%E5%8F%91%E7%89%88-%E9%80%9A%E7%9F%A5%E7%94%A8%E6%88%B7%E5%9C%A8%E7%BA%BF%E6%9B%B4%E6%96%B0%E6%96%B9%E6%A1%88.md`,
    },
    {
        title: '扒官方文档学Ts类型编程(二)',
        description: `承接上一篇扒官方文档学Ts类型编程来继续扒完类型编程的后两个章节Mapped Types和...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E6%89%92%E5%AE%98%E6%96%B9%E6%96%87%E6%A1%A3%E5%AD%A6Ts%E7%B1%BB%E5%9E%8B%E7%BC%96%E7%A8%8B%EF%BC%88%E4%BA%8C%EF%BC%89/%E6%89%92%E5%AE%98%E6%96%B9%E6%96%87%E6%A1%A3%E5%AD%A6Ts%E7%B1%BB%E5%9E%8B%E7%BC%96%E7%A8%8B%EF%BC%88%E4%BA%8C%EF%BC%89.md`,
    },
    {
        title: '扒官方文档学Ts类型编程(一)',
        description: `TypeScript作为JavaScript的一个超集带来了非常强大的类型系统，但和天生支持强类型...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E6%89%92%E5%AE%98%E6%96%B9%E6%96%87%E6%A1%A3%E5%AD%A6Ts%E7%B1%BB%E5%9E%8B%E7%BC%96%E7%A8%8B/%E6%89%92%E5%AE%98%E6%96%B9%E6%96%87%E6%A1%A3%E5%AD%A6Ts%E7%B1%BB%E5%9E%8B%E7%BC%96%E7%A8%8B.md`,
    },
    {
        title: '质量管理之CR流程建设',
        description: `今天讲一下我们团队在质量管理方面所做的事与一些经验的分享. 质量管理是我们所做工...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E8%B4%A8%E9%87%8F%E7%AE%A1%E7%90%86%E4%B9%8BCR%E6%B5%81%E7%A8%8B%E5%BB%BA%E8%AE%BE/%E8%B4%A8%E9%87%8F%E7%AE%A1%E7%90%86%E4%B9%8BCR%E6%B5%81%E7%A8%8B%E5%BB%BA%E8%AE%BE.md`,
    },
    {
        title: '【解决】前端开发中的5大痛点',
        description: `前言： 通过阅读本文你了解到这5大痛点如何避免和解决： 如何优雅且快速的切换Node...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E3%80%90%E8%A7%A3%E5%86%B3%E3%80%91%E5%89%8D%E7%AB%AF%E5%BC%80%E5%8F%91%E4%B8%AD%E7%9A%845%E5%A4%A7%E7%97%9B%E7%82%B9/%E3%80%90%E8%A7%A3%E5%86%B3%E3%80%91%E5%89%8D%E7%AB%AF%E5%BC%80%E5%8F%91%E4%B8%AD%E7%9A%845%E5%A4%A7%E7%97%9B%E7%82%B9.md`,
    },
    {
        title: '基于BPMN2.0的业务流程引擎',
        description: `BPMN.js是一个BPMN 2.0渲染工具包和web建模器。它是用JavaScript编写的，将BPMN...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E5%89%8D%E7%AB%AF%E5%BE%AE%E6%9C%8D%E5%8A%A1%E8%90%BD%E5%9C%B0%E5%AE%9E%E8%B7%B5/%E5%89%8D%E7%AB%AF%E5%BE%AE%E6%9C%8D%E5%8A%A1%E8%90%BD%E5%9C%B0%E5%AE%9E%E8%B7%B5.md`,
    },
    {
        title: '基于qiankun的微服务落地实践',
        description: `本文整理自GFE团队在前端微服务上的技术实践与经验总结,强调了整体实现过程,介绍了在...`,
        link: ``,
    },
    {
        title: '探索行为可回溯系统的应用与实现',
        description: `通过阅读本文你会了解到行为回溯系统的优点和带来的好处是什么？可以学到搭建完整的回...`,
        link: `https://github.com/gfe-team/article-backup/blob/main/%E6%8E%A2%E7%B4%A2%E8%A1%8C%E4%B8%BA%E5%8F%AF%E5%9B%9E%E6%BA%AF%E7%B3%BB%E7%BB%9F%E7%9A%84%E5%BA%94%E7%94%A8%E4%B8%8E%E5%AE%9E%E7%8E%B0/%E6%8E%A2%E7%B4%A2%E8%A1%8C%E4%B8%BA%E5%8F%AF%E5%9B%9E%E6%BA%AF%E7%B3%BB%E7%BB%9F%E7%9A%84%E5%BA%94%E7%94%A8%E4%B8%8E%E5%AE%9E%E7%8E%B0.md`,
    }
];